/**
 * 環境変数管理
 * Vite環境変数の型安全な管理
 */

export const env = {
  VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
  VITE_TEST_USER_EMAIL: import.meta.env.VITE_TEST_USER_EMAIL,
  VITE_TEST_USER_PASSWORD: import.meta.env.VITE_TEST_USER_PASSWORD,
  VITE_TEST_ADMIN_EMAIL: import.meta.env.VITE_TEST_ADMIN_EMAIL,
  VITE_TEST_ADMIN_PASSWORD: import.meta.env.VITE_TEST_ADMIN_PASSWORD,
  // API設定
  VITE_API_FALLBACK_URL: import.meta.env.VITE_API_FALLBACK_URL,
} as const

/**
 * 型安全性の確保
 */
type EnvKeys = keyof typeof env

/**
 * 環境変数を取得
 */
export const getEnv = (key: EnvKeys): string => {
  const value = env[key]
  if (!value) {
    throw new Error(`Environment variable ${key} is not defined`)
  }
  return value
}

/**
 * 必須環境変数の検証
 */
export const validateEnv = (): void => {
  const requiredVars: EnvKeys[] = [
    'VITE_SUPABASE_URL',
    'VITE_SUPABASE_ANON_KEY',
    'VITE_API_BASE_URL',
  ]

  const missingVars: string[] = []

  for (const varName of requiredVars) {
    if (!env[varName]) {
      missingVars.push(varName)
    }
  }

  if (missingVars.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missingVars.join(', ')}`
    )
  }
}

if (import.meta.env.DEV) {
  console.info('[Env] Environment variables loaded:', {
    VITE_SUPABASE_URL: env.VITE_SUPABASE_URL ? '✓' : '✗',
    VITE_SUPABASE_ANON_KEY: env.VITE_SUPABASE_ANON_KEY ? '✓' : '✗',
    VITE_API_BASE_URL: env.VITE_API_BASE_URL ? '✓' : '✗',
    VITE_APP_ENV: env.VITE_APP_ENV || 'not set',
  })
}